import React from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';

import Detail from './Detail';
import Overview from './Overview';

const TravelExpensesRequest = props => {
  const paths = {
    details: `${props.match.path}/:id`,
  };

  return (
    <Switch>
      <Route exact path={paths.details} render={routerProps => <Detail {...props} {...routerProps} />} />
      <Route render={routerProps => <Overview {...props} {...routerProps} />} />
    </Switch>
  );
};

export default withRouter(TravelExpensesRequest);
